import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=c7ad7d4e"
import script from "./MessageBox.vue?vue&type=script&lang=js"
export * from "./MessageBox.vue?vue&type=script&lang=js"
import style0 from "./MessageBox.vue?vue&type=style&index=0&id=c7ad7d4e&prod&lang=css"
import style1 from "./MessageBox.vue?vue&type=style&index=1&id=c7ad7d4e&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports